import DiscoWidgetInjector from './DiscoWidgetInjector';

export default DiscoWidgetInjector;
